import style from '@/fsd/shared/ui/static/css/commonStyle.module.scss';
import cx from 'classnames';
import React from 'react';

export const BodyTableLineItem = (props) => {
  const {
    value,
    event,
    additionalClass,
    additionalClass2,
    className,
    id,
    ...otherProps
  } = props;

  const addedClass = () => {
    let preparedClass = '';
    if (additionalClass) {
      preparedClass = additionalClass;
    }
    return preparedClass;
  };
  const addedClass2 = () => {
    let preparedClass = '';
    if (additionalClass2) {
      preparedClass = additionalClass2;
    }
    return preparedClass;
  };

  return (
    <div
      id={id}
      style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
      }}
      className={cx(
        className,
        style.BodyTableLineItem,
        style[addedClass()],
        style[addedClass2()]
      )}
      onClick={(e) => {
        if (
          additionalClass === 'optionsButton' ||
          additionalClass2 === 'optionsButton'
        )
          e.stopPropagation();
        event?.();
      }}
      {...otherProps}
    >
      {(value !== undefined && value !== null) ||
      additionalClass === 'empty' ||
      additionalClass2 === 'empty'
        ? value
        : '-'}
    </div>
  );
};

export default BodyTableLineItem;
